import React, { Component } from 'react';

import { Chart } from 'react-google-charts';

export class TimelineChartPanel extends Component {

    isDataPresent = () => {
      if (this.props.routesList.filter((route) => {
        return route.selected;
      }).length > 0) {return true} else {return false}
    }

    getCols = () => {
      return [{
          type: 'string',
          label: 'Type',
        },
        {
          type: 'string',
          label: 'barLabel',
        },
        {
          type: 'date',
          label: 'start',
        },
        {
          type: 'date',
          label: 'end',
        }
      ]
    }

    getChartData = () => {
      let _chartData = [];
      //_chartData.push(['Ident','bar', 'Start', 'End']);


      this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        _chartData.push(['Transito', route.from.name + ' - ' + route.to.name , route.startDate, route.endDate ]);
        return null;
      })
      return _chartData;
    }

    getChartColors = () => {
      return this.props.routesList.filter((route) => {
        return route.selected;
      }).map((route, index) => {
        return '' + route.pathColor;
      })

    }

    getChart = () => {
      if (this.isDataPresent()) {
        return (
          <Chart
            chartType="Timeline"
            columns={this.getCols()}
            rows={this.getChartData()}
            options={{
              colors: this.getChartColors(),
              timeline: { rowLabelStyle: { fontName: 'Open Sans', fontSize: 12, color: '#603913' },
                          barLabelStyle: { fontName: 'Open Sans', fontSize: 10 },
                          showRowLabels: false,
                          showBarLabels: true
                        },
              tooltip: { isHtml: true }
            }}
            graph_id="TimelineChart"
            width="100%"
            height="160px"
            legend_toggle
          />
        )
      } else {
        return <span></span>;
      }
    }

    render() {
        return(

          <div className={'my-pretty-chart-container'}>
            {this.getChart()}
          </div>
        );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/TimelineChartPanel.js